import {Component, OnInit} from '@angular/core';
import {AlertService} from "../../services/alert.service";

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})

export class AlertComponent {
  message:any;

  constructor(private alertService:AlertService) {
  }

  ngOnInit() {
    this.alertService.getMessage().subscribe(message => {
      this.message = message;
      setTimeout(()=> {
        this.closeAlert()
      }, 3000);

    });
  }

  closeAlert() {
    this.message = '';
  }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/component/alert/alert.component.ts